export const card: React.CSSProperties = {
  height: '100%', 
  display: 'flex', 
  flexDirection: 'column'
};

export const cardBody: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  padding: 16,
  minHeight: 0,
};

export const divider: React.CSSProperties = {
  margin: '8px',
};

export const listContainer: React.CSSProperties = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
};

export const totalsContainer: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '12px',
};

export const totalsContetntLeft: React.CSSProperties = {
  display: 'flex', 
  flexDirection: 'row', 
  justifyContent: 'center',
  alignItems: 'center',
  gap: '12px'
};

export const totalsContetntRight: React.CSSProperties = {
  display: 'flex', 
  gap: '4px'
};

export const icon: React.CSSProperties = {
  margin: 0, 
  padding: 0, 
  marginBottom: '-4px',
};

export const colorRed: React.CSSProperties = {
  color: 'red'
};

export const colorGreen: React.CSSProperties = {
  color: 'green'
};

export const colorPrimary: React.CSSProperties = {
  color: '#1677ff',
};
